<template>
    <section>
      <h3 class="centered-text">Enter Your Payment Information</h3>

      <form class="payment-info-form">
        <div class="flex-row">
          <div ref="card"></div>
          <div ref="cardErrors" class="card-errors"></div>
        </div>

        <div class="flex-row">
          <img class="credit-card-image" src="https://big-yellow-bag.s3.amazonaws.com/creditcards.jpg">
        </div>
        <button type="button" class="button" href="#" :disabled="loading || pricingAvailabilityChanged" @click="finalPricingCheck">Submit Order</button>
      </form>
    </section>
</template>

<script>
export default {
  name: 'PaymentInfo',

  data () {
    return { loading: null }
  },

  computed: {
    stripe() {
      return this.$store.state.stripe;
    },

    pricingAvailabilityChanged() {
      return this.$store.getters.pricingAvailabilityChanged;
    },
  },

  created() {
    this.elements = this.stripe.elements({
      fonts: [
        {
          cssSrc: 'https://fonts.googleapis.com/css?family=Roboto+Slab',
        },
      ],
    });
  },

  mounted() {
    // Track Spotify Alias
    this.$store.dispatch('trackSpotifyAlias');

    const style = {
      base: {
        fontFamily: '"Roboto Slab", serif',
        fontSize: '26px',
      },
      invalid: {
        color: 'red',
        iconColor: 'red',
      },
    };

    this.card = this.elements.create('card', { style, hidePostalCode: true });
    this.card.mount(this.$refs.card);

    this.setupCardListener();
  },

  methods: {
    finalPricingCheck(e) {
      this.loading = true;
      this.$store.dispatch('fetchPricing').then(() => {
        this.loading = false;
        if (!this.pricingAvailabilityChanged) {
          this.submitOrder(e);
        }
      });
    },

    async submitOrder(e) {
      e.preventDefault();
      this.loading = true
      const { token, error } = await this.stripe.createToken(this.card);
      if (error) {
        const errorElement = this.$refs.cardErrors;
        errorElement.textContent = error.message;
        this.loading = false
      } else {
        const paymentInfo = {
          sanitizedCcNumber: `XXXXXXXXXXXX${token.card.last4}`,
          cardType: token.card.brand,
          expiryDate: `${token.card.exp_month}/${token.card.exp_year}`,
        };
        this.$store.commit('setProperties', { paymentInfo });
        this.$store.dispatch('submitOrder', token.id);
        this.loading = false
      }
    },

    setupCardListener() {
      // Listens to card changes, shows errors in real time - handled by Stripe.
      this.card.addEventListener('change', (event) => {
        const displayError = this.$refs.cardErrors;
        if (event.error) {
          displayError.textContent = event.error.message;
        } else {
          displayError.textContent = '';
        }
      });
    },
  },
};
</script>

<style scoped>

section {
  margin-bottom: 1.62em;
}

.credit-card-image {
  margin: 0 auto;
}

.payment-info-form {
  max-width: 640px;
  margin: 0 auto;
  text-align: center;
}

.payment-info-form .flex-row {
  flex-direction: column;
}

label {
  flex: 1;
  text-align: center;
}

input[type="text"],
input[type="number"] {
  background-color: #F4F4F4;
  font-size: 1.62em;
  border-radius: 0.38em;
  padding: 0.38em;
  border: 1px solid #DBDBDB;
  margin: .38em .62em;
  text-align: center;
}

.flex-row {
  display: flex;
}

.flex-column {
  display: flex;
  flex-direction: column;
}

.flex-row input {
  flex: 1;
  width: 100%;
}

.StripeElement {
  background-color: #F4F4F4;
  font-size: 1.62em;
  border-radius: 0.38em;
  padding: 0.38em;
  border: 1px solid #DBDBDB;
  margin: .38em auto;
  width: 100%;
  box-sizing: border-box;
}

.StripeElement--invalid {
  border-color: red;
  border-width: 2px;
}

.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}

.card-errors {
  background-color: red;
  color: white;
  font-weight: bold;
  padding: 0 0.62em;
  border-radius: .24em;
  display: block;
  line-height: 2em;
  margin-bottom: 1em;
}
</style>
